(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name crewing.service:CrewingHelper
     *
     * @description
     *
     */
    angular
        .module('crewing')
        .service('CrewingHelper', CrewingHelper);

    function CrewingHelper($timeout,RemoteService, EventManagerService, MessageService, PopupManager, CommonMasterData, applicationConstants, CrewingAdaptor, CrewingRequest, CommonLogicService) {
        var self = this,
            crewSchedule = null,
            trainingPrograms = {},
            crewProfileImageUrls = {},
            backupCrewSchedule = null,
            backupNameCollection = null,
            unAdaptedCrewScheduleData = null,
            showInPortal=null,
            newlyAddedCrewSchedule=null,
            allEvents = null;


        var getFlags = function (flagConfigs, type) {

            switch (type) {
                case 'ignoreConflicts' :
                {
                    flagConfigs.isIgnoreConflicts = true;
                    break;
                }
                case 'useConfirm':
                {
                    flagConfigs.isContinueIllegal = false;
                    flagConfigs.isUserConfirm = true;
                    break;
                }
                case 'isContinueIllegalConfirm':
                {
                  flagConfigs.isContinueIllegal = true;
                  flagConfigs.isUserConfirm = true;
                  break;
                }
                case 'ignoreExpiryWarnings':
                {
                    flagConfigs.isIgnoreExpiries = true;
                    flagConfigs.isIgnoreExpiry = true;
                    break;
                }
                case 'ignoreRequest':
                {
                    flagConfigs.isIgnoreRequest= true;
                    break;
                }
                case 'ignoreParentHubDeletedConflict':
                {
                  flagConfigs.isIgnoreParentHubDeletedConflict = true;
                  break;
                }
            }
            return flagConfigs;
        };

        self.getCrewIds = function (crewID) {
            if(!!crewSchedule && crewSchedule.nameCollection){
                var adapted = crewSchedule.nameCollection.map(function (crew) {
                    return {crewId : crew.crewId,crewProfileId : crew.crewProfileId};
                });
              /*  var fromIndex = _.findIndex(adapted,{crewId:crewID});
                if(fromIndex > 0){
                   return adapted.slice(fromIndex);
                }else{
                    return adapted;
                }*/
                return adapted;
            }else{
                return  [];
            }

        };

      self.getManagementCrewPositions = function(successFn, errorFn){

        RemoteService.managementCrewPositions().then(
          function (response) {
            successFn(response.managementCrewPositionList);
          },
          function (error) {
            errorFn(error.msg[0]);
          }
        );
      };

        self.adaptCrewList = function (crewList) {
            angular.forEach(crewList, function (crew) {
                crew.displayName = crew.firstName + ' ' + crew.lastName + ' (' +crew.crewId + ')';
            });
            return crewList;
        };

        self.appendToCrewSchedule = function (existingCrewSchedule, newCrewScheduleData, isNotifyUpdate) {
            angular.forEach(newCrewScheduleData.nameCollection, function (nameObj) {
                var foundNameIndex = _.findIndex(existingCrewSchedule.nameCollection, {crewId: nameObj.crewId})
                if (foundNameIndex >= 0) {
                    var oldIndex = existingCrewSchedule.nameCollection[foundNameIndex].nameIndex;
                    nameObj.nameIndex = oldIndex;
                    existingCrewSchedule.nameCollection.splice(foundNameIndex, 1, nameObj);
                } else {
                    nameObj.nameIndex = existingCrewSchedule.nameCollection[existingCrewSchedule.nameCollection.length - 1].nameIndex + 1;
                    existingCrewSchedule.nameCollection.push(nameObj);
                }
            });

            angular.forEach(newCrewScheduleData.schedule, function (schedule) {
                var fundScheduleIndex = _.findIndex(existingCrewSchedule.schedule, {crewId: schedule.crewId})
                if (fundScheduleIndex >= 0) {
                    existingCrewSchedule.schedule.splice(fundScheduleIndex, 1, schedule);
                } else {
                    existingCrewSchedule.schedule.push(schedule);
                }
            });
            if(isNotifyUpdate == undefined || isNotifyUpdate){
            	EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.SCHEDULE_UPDATED);
            }
        };

        self.appendToSMSList = function(existingSMSData, newSMSData){
        	angular.forEach(newSMSData.dtoList, function (SMSObj) {
				var foundIndex = _.findIndex(existingSMSData.dtoList, {smsID: SMSObj.smsID})
				if (foundIndex >= 0) {
					existingSMSData.dtoList.splice(foundIndex, 1, SMSObj);
				} else {
					existingSMSData.dtoList.push(SMSObj);
				}
			});
        }

        self.searchSMSList = function (searchReq, successFn, errorFn){
        	var requestParam = CrewingRequest.getMessageManagerSearchRequest(searchReq);
        	RemoteService.searchSMSList.call(this, requestParam).then(
				function (response) {
					successFn(response);
				},
				function (error) {
					errorFn(error);
				}
    		);
        }

        self.getCrewIdFromCrewProfileID = function (crewProfileIdParam, nameCollection) {
            var crew = _.findWhere(nameCollection, {crewProfileId: crewProfileIdParam});
            return !!crew && crew.crewId || null;
        };

        self.getCrewFromCrewProfileID = function (crewProfileIdParam, nameCollection) {
            var crew = _.findWhere(nameCollection, {crewProfileId: crewProfileIdParam});
            return crew || null;
        };

        self.updateSelectedCrews = function (existingSchedule, crewIds, updatedSchedule) {
            var crewSchedule = existingSchedule && existingSchedule.schedule;
            var nameCollection = existingSchedule && existingSchedule.nameCollection;

            var updatedCrewSchedule = updatedSchedule && updatedSchedule.schedule;
            var updatedNameCollection =  updatedSchedule && updatedSchedule.nameCollection;

            var isUpdated = false;

            var updateNameCollection = function (id) {

                var foundIndexExisting = _.findIndex(nameCollection, function (tmp) {
                    return tmp.crewId == id;
                });

                var foundIndexNew = _.findIndex(updatedNameCollection, function (tmp) {
                    return tmp.crewId == id;
                });

                if (foundIndexExisting >= 0 && foundIndexNew >=0 ) {
                    nameCollection.splice(foundIndexExisting, 1, updatedNameCollection[foundIndexNew]);
                    return true;
                }
                return false;
            };

            var updateDutyCollection = function (id) {

                var crew = _.findWhere(crewSchedule, {crewId: id});

                if (!!crew) {
                    var updateRecord = _.findWhere(updatedCrewSchedule, {crewId: id});
                    if (!!updateRecord) {
                        crew.adaptedRosterDutyDTOs = updateRecord.adaptedRosterDutyDTOs;
                        crew.rosterDutyDTOs = updateRecord.rosterDutyDTOs;
                        return true;
                    }
                }
                return false;
            };


            angular.forEach(crewIds, function (id) {
                isUpdated = updateDutyCollection(id) || isUpdated;
                isUpdated = updateNameCollection(id) || isUpdated;
            });

            if (isUpdated) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.SCHEDULE_UPDATED);
            }
        };


        self.getAssignTrainingFlags = function () {
            return {
                isContinueIllegal: true,
                isUserConfirm: false,
                isExpiryUpdatable: false,
                isIgnoreConflicts: false,
                isIgnoreExpiries: false,
                isIgnoreParentHubDeletedConflict: false
            };
        };

        /**
         * Move given Crew to top of the collection
         * @param crewIds String or Array
         */
        self.moveCrewToTop = function (crewIds) {
            var _move = function (crewId) {
                var currentIndex = _.findIndex(crewSchedule.schedule, {crewId: crewId});
                var old = crewSchedule.schedule[currentIndex];
                crewSchedule.schedule.splice(currentIndex, 1);
                crewSchedule.schedule.splice(0, 0, old);
                _moveCrewName(crewId);
            };

            var _moveCrewName = function (crewId) {
                var currentIndex = _.findIndex(crewSchedule.nameCollection, {crewId: crewId});
                var old = crewSchedule.nameCollection[currentIndex];
                crewSchedule.nameCollection.splice(currentIndex, 1);
                crewSchedule.nameCollection.splice(0, 0, old);
            };

            if (crewIds instanceof Array) {
                angular.forEach(crewIds, function (id) {
                    _move(id);
                });
            } else {
                _move(crewIds);
            }
        };


        self.scrollToTopCrewSchedule = function (d) {
            $timeout(function (d) {
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.RESET_SCROLL_TOP);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, false);
            }, 0);
        };



        self.moveCrewToTopAndRemoveOthers = function (crewId, searchParam) {
            if (!!unAdaptedCrewScheduleData && unAdaptedCrewScheduleData.crewScheduleDTOs && unAdaptedCrewScheduleData.crewScheduleDTOs.length > 0) {
                var crewToBeMoved = _.find(unAdaptedCrewScheduleData.crewScheduleDTOs, function (obj) {
                    return obj.crewDTO.crewId == crewId;
                });

                if (!!crewToBeMoved) {
                    var tmp = angular.copy(unAdaptedCrewScheduleData);
                    tmp.crewScheduleDTOs = [crewToBeMoved];
                    var adapted = CrewingAdaptor.searchCrewScheduleAdaptor(tmp, searchParam);
                    self.setCrewScheduleData(adapted);
                }
            }
        };

        self.saveCopyOfCrewSchedule = function () {
            backupCrewSchedule = crewSchedule.schedule;
            backupNameCollection = crewSchedule.nameCollection;
        };

        self.rollbackSaveCrewSchedule = function (searchParam) {
            if (!!unAdaptedCrewScheduleData) {
                var adapted = CrewingAdaptor.searchCrewScheduleAdaptor(unAdaptedCrewScheduleData, searchParam);
                self.setCrewScheduleData(adapted);
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.CREWING.SCHEDULE_UPDATED);
            }
        };


        /**
         * Perform assign training actions base on response flags
         * @param assignTrainingResponse
         */
        self.assignTrainingActionList = function (assignTrainingRequest, assignTrainingResponse, trainingFlagsConfig, assignTrainingCallback, successCallBack, userCancelCallback, isShowInPortal) {
            /*Is Success - TRUE*/
            if(!angular.isUndefined(isShowInPortal)){
                assignTrainingRequest.isShowInPortal = isShowInPortal
            }
            if (assignTrainingResponse.success) {
                /* $uibModalInstance.close([vm.model.selectedTrainingParam.crewId]);*/
                MessageService.success(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_SUCCESS);

                for (var key in assignTrainingResponse.otherHubSyncResponses) {
                  if (assignTrainingResponse.otherHubSyncResponses.hasOwnProperty(key)) {
                    if (assignTrainingResponse.otherHubSyncResponses[key]) {
                      MessageService.success('Tenant: ' + key + ', Status: SUCCESS');
                    } else {
                      MessageService.warning('Tenant: ' + key + ', Status: FAILED');
                    }
                  }
                }

              if (assignTrainingResponse.otherBlockIllegal) {
                    MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_TRAINING_OTHER_BLOCKS_ILLEGAL);
                }
                if (!!successCallBack) {
                    successCallBack(assignTrainingResponse, isShowInPortal);
                }
            }

            if (assignTrainingResponse.operationFailed) {
              MessageService.warning(MessageService.MESSAGES.CREWING.ASSIGN_BULK_TRAINING_FAILED);
            }

            /*is conflicts exist*/
            if (assignTrainingResponse.conflictsExist) {
                var param = {
                    title: 'Confirmation',
                    messages: [
                        MessageService.MESSAGES.CREWING.TRAINING_CONFLICT_EXIST,
                        MessageService.MESSAGES.CREWING.TRAINING_CONFLICT_EXIST_DESC,
                        MessageService.MESSAGES.COMMON.CONFIRM_CONTINUE]
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, onConflictExistClose);
            }

            if(assignTrainingResponse.parentHubDeletedConflictExist) {
              var param = {
                title: 'Confirmation',
                messages: [
                  MessageService.MESSAGES.TRAINING_SCHEDULE.PARENT_HUB_TRAINING_DELETED,
                  MessageService.MESSAGES.COMMON.CONFIRM_CONTINUE]
              };
              PopupManager.openModal('CONFIRM_DIALOG', param, onParentHubDeletedConflictExistClose);
            }

            /*Is Illegal*/
            if (!assignTrainingResponse.success && assignTrainingResponse.regulationMap !=null) {
                var regulationDetailParam = {
                    regulationMap: assignTrainingResponse.adaptedRegulationMap,
                    onAcceptPassBackParam: {}//Send Dummy object to verify user confirm action
                };
                PopupManager.openModal('REGULATION_DETAILS', regulationDetailParam, onCloseRegulationPopupForTraining);
            }

            if (assignTrainingResponse.crewRequestExsit) {
                var param = {
                    title: 'Confirmation',
                    messages: [MessageService.MESSAGES.CREWING.TRAINING_CONFLICT_WITH_CREW_REQUEST]
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, onCloseCrewRequestExistsForTraining);
            }
            /*Is Expiry Warnings*/
            if (assignTrainingResponse.expiryWarnExist) {
                var param = {
                    title: 'Confirmation',
                    messages: self.getExpiryMsg(assignTrainingResponse)
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, onConfirmExpiryWarnings);
            }


            function onConflictExistClose(param) {
                if (!!param) {
                    assignTrainingCallback(assignTrainingRequest, getFlags(trainingFlagsConfig, 'ignoreConflicts'), getFlags(trainingFlagsConfig, 'ignoreExpiryWarnings'), isShowInPortal);
                }else{
                    if(!!userCancelCallback){
                        userCancelCallback();
                    }
                }
            }

          function onParentHubDeletedConflictExistClose(param) {
            if (!!param) {
              assignTrainingCallback(assignTrainingRequest, getFlags(trainingFlagsConfig, 'ignoreParentHubDeletedConflict'), getFlags(trainingFlagsConfig, 'ignoreExpiryWarnings'), isShowInPortal);
            } else {
              if (!!userCancelCallback) {
                userCancelCallback();
              }
            }
          }

            function onCloseRegulationPopupForTraining(params) {
                if (!!params) {
                    assignTrainingCallback(assignTrainingRequest, getFlags(trainingFlagsConfig, 'useConfirm'), getFlags(trainingFlagsConfig, 'ignoreExpiryWarnings'), isShowInPortal);
                }else{
                    if(!!userCancelCallback){
                        userCancelCallback();
                    }
                }
            }
            function onCloseCrewRequestExistsForTraining(params) {
                if (!!params) {
                    assignTrainingCallback(assignTrainingRequest, getFlags(trainingFlagsConfig, 'ignoreRequest'));
                }else{
                    if(!!userCancelCallback){
                    userCancelCallback();
                    }
                }
            }

            function onConfirmExpiryWarnings(params) {
                if (!!params) {
                    assignTrainingCallback(assignTrainingRequest, getFlags(trainingFlagsConfig, 'isContinueIllegalConfirm'), getFlags(trainingFlagsConfig, 'ignoreExpiryWarnings'), isShowInPortal);
                }else{
                    if(!!userCancelCallback){
                        userCancelCallback();
                    }
                }
            }
        };


        self.getExpiryMsg = function (assignTrainingResponse) {
            var msg = [];
            if (!!assignTrainingResponse.currentExpiryDate && !!assignTrainingResponse.newExpiryDate) {
                msg.push('New Expiry Date ' + assignTrainingResponse.newExpiryDate + ' is less than Current Expiry Date ' + assignTrainingResponse.currentExpiryDate);
            }
            if (!!assignTrainingResponse.daysBeforeExpiry) {
                msg.push('Training assigned ' + assignTrainingResponse.daysBeforeExpiry + ' day(s) before Expiry.');
            }

            if (!!assignTrainingResponse.pendingResultDate) {
                msg.push('Training with pending results exist for ' + assignTrainingResponse.pendingResultDate);
            }
            msg.push(MessageService.MESSAGES.COMMON.CONFIRM_CONTINUE);
            return msg;
        };


        self.isSwapExpiryMessage = function (swapResponse) {
            var msg = [];
            angular.forEach(swapResponse, function (crew) {
                if (crew.expiryWarnExist) {
                    msg.concat(self.getExpiryMsg(crew))
                }
            });
            return msg;
        };


        self.getDutiesForCrew = function (crewId, fromDate, noOfDays, crewScheduleBlockId) {
            noOfDays = noOfDays || 1;

            var getDuties = function (allDuties, fromDate, noOfDays, crewScheduleBlockId) {
                var days = [fromDate];
                var nextDutyString = '';
                var dutiesForMsgContent = [];
                if (noOfDays > 1) {
                    var tmpMo = moment(fromDate, applicationConstants.SETTINGS.DATE_FORMAT);
                    for (var i = 1; i < noOfDays; i++) {
                        days.push(tmpMo.add(1, 'd').format(applicationConstants.SETTINGS.DATE_FORMAT));
                    }
                }

                angular.forEach(allDuties, function (duty) {
                	if(((!!crewScheduleBlockId && duty.crewScheduleBlockId === crewScheduleBlockId) ||
                			((angular.isUndefined(crewScheduleBlockId) || crewScheduleBlockId == null ) && days.indexOf(duty.checkInDate) >= 0))
                			&& dutiesForMsgContent.indexOf(duty.crewScheduleBlockId) === -1){
                		if (duty.eventCategory == 'LEAVE') {
                            nextDutyString += (duty.blockName + ' ' + duty.checkInDate +'(L)'+ '\n' );
                        } else {
                            nextDutyString += (duty.blockName + '  CHECK-IN : ' + duty.checkInDate + ' - ' + duty.checkInTime+ '(L)' + ' CHECK-OUT : ' + duty.checkOutDate + ' - ' + duty.checkOutTime +'(L)'+ '\n' );
                        }
                        dutiesForMsgContent.push(duty.crewScheduleBlockId);
                	}
                });
                return nextDutyString;
            };

            var crew = _.find(crewSchedule.schedule, {'crewId': crewId});
            return crew.rosterDutyDTOs.length ? getDuties(crew.rosterDutyDTOs, fromDate, noOfDays, crewScheduleBlockId) : '';
        };

        /**
         * Check whether adapted block contain LEAVE, if so return true
         * @param adaptedBlock
         * @returns {boolean}
         */
        self.isLeaveBlock = function (adaptedBlock) {
            var returnFlag = false;
            var checkBlock = function (adaptedBlockParam) {
                var isLeave = false;
                if (adaptedBlockParam && adaptedBlockParam.events && adaptedBlockParam.events.length > 0) {
                    for (var i = 0; i < adaptedBlockParam.events.length; i++) {
                        var event = adaptedBlockParam.events[i];
                        if (event.eventCategory == 'LEAVE') {
                            isLeave = true;
                            break;
                        }

                    }
                }
                return isLeave;
            };

            if (adaptedBlock instanceof Array) {
                for (var i = 0; i < adaptedBlock.length; i++) {
                    var block = adaptedBlock[i];
                    returnFlag = checkBlock(block);
                    if (returnFlag) {
                        break;
                    }
                }
            } else {
                returnFlag = checkBlock(adaptedBlock);
            }

            return returnFlag;
        };


        /**
         * Get All blocks for a Given Crew for a period
         * @param crewId
         * @param fromDate
         * @param toDate
         * @returns {Array}
         */
        self.getBlocksForCrew = function (crewId, fromDate, toDate) {
            var blocks,
                tMo,
                tMoFromDate = moment(fromDate, applicationConstants.SETTINGS.DATE_FORMAT),
                tMoToDate = moment(toDate, applicationConstants.SETTINGS.DATE_FORMAT),
                tmp = _.find(crewSchedule.schedule, {crewId: crewId});
            if (!!tmp) {
                blocks = tmp.adaptedRosterDutyDTOs.filter(
                        function (duty) {
                            tMo = moment(duty.patternStartDate, applicationConstants.SETTINGS.DATE_FORMAT);
                            return tMo.isBetween(tMoFromDate, tMoToDate, null, '[]');
                        }
                    ) || [];
            }

            return blocks;
        };

        /**
         * Get Crew Schedule helper and response adaptor
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.searchCrewSchedule = function (param, successFn, errorFn, isShowLoading) {
            if (angular.isUndefined(isShowLoading)) {
                isShowLoading = true;
            }
            this.headerParam = {'show-loading': isShowLoading};

            var cloneParam = angular.copy(param);
            if (cloneParam.hasOwnProperty('isNewSearch')) {
                delete cloneParam.isNewSearch;
            }

            RemoteService.searchCrewSchedule.call(this, cloneParam).then(
                function (response) {
                    var clone = angular.copy(response);
                    updateUnadaptedCrewSchedule(clone, param);
                    successFn(CrewingAdaptor.searchCrewScheduleAdaptor(response, param));
                },
                function (error) {
                    errorFn(error);
                }
            );

            function updateUnadaptedCrewSchedule(data, searchParam) {
                var cloneCopy = angular.copy(data);
                if (!!searchParam.isNewSearch || (unAdaptedCrewScheduleData == null )) {
                    searchParam.isNewSearch = false;
                    unAdaptedCrewScheduleData = cloneCopy || null;
                } else {
                    angular.forEach(cloneCopy.crewScheduleDTOs, function (obj) {
                        var foundIndex = _.findIndex(unAdaptedCrewScheduleData.crewScheduleDTOs, function (tmp) {
                            return tmp.crewDTO.crewId == obj.crewDTO.crewId
                        });

                        if (foundIndex >= 0) {
                            unAdaptedCrewScheduleData.crewScheduleDTOs.splice(foundIndex, 1, obj);
                        } else {
                            unAdaptedCrewScheduleData.crewScheduleDTOs.push(obj);
                        }
                    });
                }
            }
        };


        /**
         * Get open pairing helper service
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.searchOpenPairings = function (param, successFn, errorFn) {
            RemoteService.searchOpenPairings(param).then(
                function (response) {
                    successFn(CrewingAdaptor.searchOpenPairingsAdaptor(response, param));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        self.getCrewScheduleBlockViewFlagsEnable = function (successFn) {
            if(showInPortal!==null){
                successFn(showInPortal);
            }else{
                RemoteService.getCrewScheduleBlockViewFlagsEnable().then(
                    function (response) {
                        if(response.success){
                            successFn(response.appParamValueDTO);
                            self.setCrewScheduleBlockViewFlagsEnable(response.appParamValueDTO);
                        }
                    },
                    function (error) {
                        MessageService.error(error)
                    }
                );
            }
        };

        self.updateVisibilityFlagCrews = function(crewMembers, searchParams, onSuccessFn){
            var crewProfileIds=null;
            if(!!crewMembers){
                crewProfileIds=[];
                _.each(crewMembers,function(item) {
                    crewProfileIds.push(item.crewDTO.crewProfileId);
                });
            }

            var request = CrewingRequest.getShowInCrewPortalAll(crewProfileIds, searchParams);
            RemoteService.showAllHideCrewScheduleBlocks(request).then(
                function (response) {
                    if(response.success){
                        onSuccessFn(response);
                    }
                },
                function (error) {
                    MessageService.error(error)
                }
            );
        };


        self.setCrewScheduleBlockViewFlagsEnable = function(paramVal){
            showInPortal = paramVal
        };

        self.updateBlockVisibilityFlag = function (blocks,isVisible,onSuccessFn) {
            var request = {
                crewScheduleBlockIds : blocks.map(function (block) {
                    return block.crewScheduleBlockId;
                }),
                userConfirmNotShowingInCrewPortal : isVisible
            };

            RemoteService.updateCrewScheduleBlockFlags(request).then(
                function (response) {
                    if(response.success){
                        onSuccessFn(response);
                    }
                },
                function (error) {
                    MessageService.error(error)
                }
            );
        };

        /**
         * Acknowledge Duty Service
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.acknowledgeDuty = function (param, successFn, errorFn) {

          var request = CrewingRequest.acknowledgeDutyRequest(param);
          RemoteService.acknowledgeDuty(request).then(
            function (response) {
              successFn(response);
            },
            function (error) {
              errorFn(error);
            }
          );
        };

      /**
       * Convert to normal sick Service
       * @param param
       * @param successFn
       * @param errorFn
       */
      self.convertBackToSick = function (param, successFn, errorFn) {

        //var request = CrewingRequest.acknowledgeDutyRequest(param);
        RemoteService.convertToSick(param).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          }
        );
      };

        /**
         * Delete Block Helper Service
         * @param param
         * @param isComplementFilled
         * @param successFn
         * @param errorFn
         */
        self.unAssignBlock = function (param, crewDTOs, successFn, errorFn) {

			var isComplementFilled = false;
			try{
				if(param.hasOwnProperty('isComplementFilled')){
					isComplementFilled = param.isComplementFilled;
				}
			} catch(e) {
				isComplementFilled = false;
			}

            var request = CrewingRequest.unAssignBlockRequest(param, crewDTOs, isComplementFilled);
            RemoteService.unAssignBlock(request).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Search Pattern Helper Service
         * @param crewProfileId
         * @param date
         * @param successFn
         * @param errorFn
         */
        self.searchPatternData = function (crewProfileId, date, event, crewScheduleBlockId, successFn, errorFn) {
            var request = CrewingRequest.patternSearchRequest(crewProfileId, date, event, crewScheduleBlockId);
            RemoteService.searchPatternData(request).then(
                function (response) {
                    successFn(CrewingAdaptor.searchPatternDataAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };


        /**
         * Swap Duty Helper Service
         * @param firstDuty
         * @param secondDuty
         * @param successFn
         * @param errorFn
         */
        self.swap = function (firstDuty, secondDuty,crewDTOs, successFn, errorFn, isUserConfirmed, isIgnoreExpiry, isShowInPortal) {
            var request = CrewingRequest.swapRequest(firstDuty, secondDuty,crewDTOs, isUserConfirmed, isIgnoreExpiry, isShowInPortal);
            RemoteService.swap(request).then(
                function (response) {
                    successFn(CrewingAdaptor.swapResponseAdaptor(response, crewSchedule));
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        /**
         * Get Pattern By Id helper function
         * @param patternID
         * @param successFn
         * @param errorFn
         */
        self.getPatternById = function (patternID, successFn, errorFn) {
            RemoteService.getPatternById(patternID).then(
                function (response) {
                    successFn(CrewingAdaptor.patternByIdAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Assign pattern helper service
         * @param successFn
         * @param errorFn
         *
         */
        self.assignPattern = function (crewProfileId, pattern, isRequest, isCallFromDayOff, isObsFlight, isHideinCrewPortal, isContinueIllegal, isUserConfirm, isShowInPortal, crewScheduleBlockId,isComplementFilled,isTargetHoursValid,sbyCallOutDateTime,isAirportRecencyOverridden,dutyChangeReason,message,overriddenViolations,successFn, errorFn) {
          if (crewScheduleBlockId === null || crewScheduleBlockId === undefined){
            var param = CrewingRequest.assignPatternRequest(crewProfileId, pattern, isRequest, isCallFromDayOff, isObsFlight, isHideinCrewPortal, isContinueIllegal, isUserConfirm, isShowInPortal,isComplementFilled,isTargetHoursValid,isAirportRecencyOverridden,dutyChangeReason,message,overriddenViolations);
            RemoteService.assignPattern(param).then(
              function (response) {
                successFn(CrewingAdaptor.assignPatternAdaptor(response));
              },
              function (error) {
                errorFn(error);
              }
            );
        }else{
          var param = CrewingRequest.assignSbyPatternRequest(crewProfileId, pattern, crewScheduleBlockId,isUserConfirm,isTargetHoursValid,sbyCallOutDateTime);
          console.log(param);
          RemoteService.assignPatternForSby(param).then(
            function (response) {
              successFn(CrewingAdaptor.assignPatternAdaptor(response));
            },
            function (error) {
              errorFn(error);
            }
          );
        }

      };


		self.replacePattern = function (crewProfileId, pattern, isRequest, isCallFromDayOff, isContinueIllegal, isUserConfirm, isShowInPortal, crewScheduleBlockId,
                                      previousCrewScheduleBlockId,checkInDate,checkInTime,patternName,isTargetHoursValid,crewDTOs, isAirportRecencyOverridden, successFn, errorFn) {
        if (crewScheduleBlockId === null || crewScheduleBlockId === undefined){
          var param = CrewingRequest.replacePatternRequest(crewProfileId, pattern, isRequest, isCallFromDayOff, isContinueIllegal, isUserConfirm, isShowInPortal,
            previousCrewScheduleBlockId,checkInDate,checkInTime,patternName,isTargetHoursValid,crewDTOs, isAirportRecencyOverridden);
          RemoteService.replacePattern(param).then(
            function (response) {
              successFn(CrewingAdaptor.assignPatternAdaptor(response));
            },
            function (error) {
              errorFn(error);
            }
          );
        }else{
          var param = CrewingRequest.assignSbyPatternRequest(crewProfileId, pattern, crewScheduleBlockId,isUserConfirm,isTargetHoursValid);
          console.log(param);
          RemoteService.assignPatternForSby(param).then(
            function (response) {
              successFn(CrewingAdaptor.assignPatternAdaptor(response));
            },
            function (error) {
              errorFn(error);
            }
          );
        }

      };

      /**
         * Get All Trainings Helper Service
         * @param date
         * @param successFn
         * @param errorFn
         */
        self.getTrainings = function (date, crewProfileId, successFn, errorFn) {
            var param = CrewingRequest.trainingRequest(date, crewProfileId);
            var context = {
                headerParam: {'show-loading': false}
            };
            RemoteService.getTrainings.call(context, param).then(
                function (trainings) {
                    successFn(CrewingAdaptor.trainingsAdaptor(trainings));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };


        /**
         * Get Events Helper service
         * @param successFn
         * @param errorFn
         * @param selectedDate
         */
        self.getEvents = function (successFn, errorFn, selectedDate) {
            if(!!allEvents){
                successFn(allEvents);
            }else{
                var context = {
                    headerParam: {'show-loading': false}
                };
                RemoteService.loadEventsForPairing.call(context, selectedDate).then(
                    function (events) {
                        allEvents = CrewingAdaptor.eventsAdaptor(events);
                        successFn(allEvents);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            }
        };

        /**
         * Filter Crew Schedule
         * @param filterParam
         * @param successFn
         * @param errorFn
         */
        self.dofilterCrewSchedule = function (filterParam, successFn, errorFn) {
            var filterRequest = CrewingRequest.filterCrewScheduleRequest(filterParam);
            RemoteService.filterCrewSchedule(filterRequest).then(
                function (filteredResponse) {
                    successFn(CrewingAdaptor.filterScheduleResponseAdaptor(filteredResponse),filterRequest);
                },
                function (error) {
                    errorFn(error);
                });
        };

        /**
         * Assign Training helper service
         * @param trainingData
         * @param successFn
         * @param errorFn
         */
        self.assignTraining = function (trainingData, flags, showInCrewPortal, isHideinCrewPortal, successFn, errorFn) {
            var param = CrewingRequest.assignTrainingRequest(trainingData, flags, showInCrewPortal, isHideinCrewPortal);
            RemoteService.assignTraining(param).then(
                function (events) {
                    successFn(CrewingAdaptor.assignTrainingAdaptor(events));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Assign Event helper service
         * @param assignEventFormData
         * @param successFn
         * @param errorFn
         */
        self.assignEditEvent = function (assignEventFormData, isContinueIllegal, isUserConfirm,dutyChangeReason,message, violatedRegulations, successFn, errorFn) {
            var param;
            if (assignEventFormData.isEditMode) {
                param = CrewingRequest.editEventRequest(assignEventFormData, isContinueIllegal, isUserConfirm);
                RemoteService.editEvent(param).then(onSuccess, onError);
            } else {
                param = CrewingRequest.assignEventRequest(assignEventFormData, isContinueIllegal, isUserConfirm,dutyChangeReason,message, violatedRegulations);
                RemoteService.assignEvent(param).then(onSuccess, onError);
            }

            function onSuccess(events) {
                successFn(CrewingAdaptor.assignEventAdaptor(events));
            }

            function onError(error) {
                errorFn(error);
            }

        };

      self.assignDirectOfcEvent = function (assignEventFormData, isContinueIllegal, isUserConfirm, successFn, errorFn) {
        var param;
        param = CrewingRequest.assignEventRequest(assignEventFormData, isContinueIllegal, isUserConfirm,null,null);
        RemoteService.assignOfcDirectEvent(param).then(onSuccess, onError);

        function onSuccess(events) {
          successFn(CrewingAdaptor.assignEventAdaptor(events));
        }

        function onError(error) {
          errorFn(error);
        }

      };

        self.getCrewIdsFromBlockDetails = function (blockDetails) {
            var crewIds = [];
            if (blockDetails && blockDetails.assignedCrewDetailDTOs) {
                angular.forEach(blockDetails.assignedCrewDetailDTOs, function (crew) {
                    crewIds.push(crew.crewId);
                });
            }
            return crewIds;
        };

        self.getCrewIdFromAdaptedBlock = function (adaptedBlock) {
            if (!!adaptedBlock && !!adaptedBlock.events) {
                var crew = _.find(adaptedBlock.events, function (event) {
                    return !!event.crewInfo
                });
                if (!!crew) {
                    return crew.crewInfo && crew.crewInfo.crewId;
                }
            }
            return null;
        };


        /**
         * Get Edit event helper function
         * @param crewScheduleBlockId
         * @param successFn
         * @param errorFn
         */
        self.getEditEventDetails = function (crewScheduleBlockId, successFn, errorFn) {
            RemoteService.getEditEventDetails(crewScheduleBlockId).then(
                function (response) {
                    successFn(CrewingAdaptor.editEventDetailsAdaptor(response))
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Edit Block chackIn checkOut helper
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.updateCheckInCheckout = function (param, successFn, errorFn) {
            var param = CrewingRequest.checkInCheckOutRequest(param);
            RemoteService.updateCheckInCheckout(param).then(
                function (response) {
                    successFn(CrewingAdaptor.assignPatternAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };


        /**
         * Get Traning Programs by Category code
         * @param programCode
         * @param successFn
         * @param errorFn
         */
        self.getTrainingProgramsByCategoryCode = function (programCode, successFn, errorFn) {
            if (!!trainingPrograms[programCode]) {
                successFn(trainingPrograms[programCode]);
            } else {
                RemoteService.getTrainingProgramsByCategoryCode(programCode).then(
                    function (response) {
                        trainingPrograms[programCode] = response.trainingProgramList;
                        successFn(trainingPrograms[programCode]);
                    },
                    function (error) {
                        errorFn(error);
                    }
                );
            }
        };


        /**
         * Get Flight Occurring Events helper service
         * @param selectedDate
         * @param successFn
         * @param errorFn
         */
        self.getFlightOccurringEvents = function (selectedDate, successFn, errorFn) {
            RemoteService.getFlightOccurringEvents(selectedDate).then(
                function (events) {
                    successFn(CrewingAdaptor.flightOccurringEventsAdaptor(events));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get Regulations helper function
         * @param crewProfileId
         * @param crewScheduleBlockId
         * @param successFn
         * @param errorFn
         */
        self.getRegulation = function (crewProfileId, crewScheduleBlockId, successFn, errorFn) {
            var param = CrewingRequest.regulationRequest(crewProfileId, crewScheduleBlockId);
            RemoteService.getRegulation(param).then(
                function (response) {
                    successFn(CrewingAdaptor.regulationAdaptor(response))
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get pax messages helper function
         */

        self.getPaxMessageDet = function (crewProfileId, crewScheduleBlockId, successFn, errorFn) {
            var param = CrewingRequest.regulationRequest(crewProfileId, crewScheduleBlockId);
            RemoteService.getPaxMsgDetails(param).then(
                function (response) {
                    successFn(response)
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get History Helper function
         * @param crewProfileId
         * @param selectedDate
         * @param successFn
         * @param errorFn
         */
        self.getHistory = function (crewProfileId, selectedDate, successFn, errorFn) {
            var param = CrewingRequest.historyRequest(crewProfileId, selectedDate);
            RemoteService.getHistory(param).then(
                function (response) {
                    successFn(CrewingAdaptor.historyAdaptor(response))
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Cut paste duty helper service
         * @param params
         * @param successFn
         * @param errorFn
         */
        self.cutPasteDuty = function (params, successFn, errorFn) {
            var requestParam = CrewingRequest.cutPasteDutyRequest(params);
            RemoteService.cutPasteDuty(requestParam).then(
                function (response) {
                    successFn(CrewingAdaptor.cutPasteDutyAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };


        /**
         * Copy paste helper function
         * @param params
         * @param successFn
         * @param errorFn
         */
        self.copyPasteDuty = function (params, successFn, errorFn) {
            var req = CrewingRequest.copyPasteRequest(params);
            RemoteService.copyPasteDuty(req).then(
                function (response) {
                    successFn(CrewingAdaptor.copyPasteDutyAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Save memo helper service
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.saveMemo = function (param, successFn, errorFn) {
            var req = CrewingRequest.saveMemoRequest(param);
            RemoteService.saveMemo(req).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

      self.notifyCrewScheduleChange = function (param, successFn, errorFn) {
        RemoteService.notifyCrewScheduleChange(param).then(
          function (response) {
            successFn(response);
          },
          function (error) {
            errorFn(error);
          }
        );
      };


        /**
         * Delete Memo helper function
         * @param memoId
         * @param version
         * @param successFn
         * @param errorFn
         */
        self.deleteMemo = function (memoId, version, successFn, errorFn) {
            RemoteService.deleteMemo(memoId, version).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Search for a Memo for a crew and for a given day
         * @param crewId
         * @param day
         * @returns {memo}
         */
        self.getMemoForDayAndCrew = function (crewId, day) {
            var tmpMemo = null;
            var tmp;
            var objWithMemoes;
            if (!!crewSchedule) {
                tmp = _.find(crewSchedule.schedule, {crewId: crewId});

                if (!!tmp) {
                    objWithMemoes = _.find(tmp.adaptedRosterDutyDTOs, function (dto) {
                        return dto.eventType == 'ICON' && angular.isDefined(dto['MEMO']);
                    });
                    if (!!objWithMemoes) {
                        tmpMemo = _.find(objWithMemoes.MEMO, {memoDate: day});
                    }
                }
            }
            return tmpMemo;
        };


        /**
         * Get CrewScheduleBlcokId's from Events
         * @param events
         * @returns {*}
         */
        self.getCrewScheduleBlockId = function (events) {
            var tmp;
            var result;
            for (var i = 0; i < events.length; i++) {
                tmp = events[i];
                if (!!tmp.crewScheduleBlockId) {
                    result = {
                        blockId: tmp.crewScheduleBlockId,
                        patternType: tmp.patternType,
                        crewInfo: tmp.crewInfo
                    };
                    break;
                }
            }
            return result;
        };


        self.getDutyAndCrewCollectionFromSelectedBlocks = function (blocks) {
            var adapted = [];
            angular.forEach(blocks, function (b) {
                if (b.eventType == 'PATTERN') {
                    adapted.push(self.getCrewScheduleBlockId(b.events));
                }
            });
            return adapted;
        };

        /**
         * Get set of crews between given from and to Crews
         * as appear in UI
         * @param selectedCrewCol  - []
         * @returns {Array}
         */
        self.getCrews = function (selectedCrewCol) {
            var returnCrews = [];
            var fromIndex = selectedCrewCol.reduce(function (previous, current) {
                if (previous == -1) {
                    return _.findIndex(crewSchedule.schedule, {crewId: current.crewId});
                } else {
                    var index = _.findIndex(crewSchedule.schedule, {crewId: current.crewId});
                    if (index < previous) {
                        return index;
                    } else {
                        return previous;
                    }
                }
            }, -1);


            var toIndex = selectedCrewCol.reduce(function (previous, current) {
                if (previous == -1) {
                    return _.findIndex(crewSchedule.schedule, {crewId: current.crewId});
                } else {
                    var index = _.findIndex(crewSchedule.schedule, {crewId: current.crewId});
                    if (index > previous) {
                        return index;
                    } else {
                        return previous;
                    }
                }
            }, -1);


            while (fromIndex <= toIndex) {
                returnCrews.push(crewSchedule.schedule[fromIndex++]);
            }

            return returnCrews;
        };

        self.getFirstDutyForPairing = function (pairing) {
            if (!!pairing && pairing.eventType == 'PATTERN') {
                var obj;
                for (var i = 0; i < pairing.events.length; i++) {
                    obj = pairing.events[i];
                    if (obj.type == 'DUTY') {
                        return obj;
                    }

                }
            }
            return null;
        };

        /**
         * check pairing is open or close
         * @param patternId
         * @param crewTypeCode
         * @param successFn
         * @param errorFn
         */
        self.isPairingOpen = function (patternId, crewTypeCode, successFn, errorFn) {
            var param = CrewingRequest.checkPairingOpenRequest(patternId, crewTypeCode);
            RemoteService.isPairingOpen(param).then(
                function (response) {
                    if (response.success) {
                        successFn(response.open);
                    } else {
                        errorFn(response.errors[0]);
                    }
                },
                function (error) {
                    errorFn(error)
                }
            );
        };

        self.isWarningCheckApplicable = function (crewTypeMasterCode, patternType) {
            return crewTypeMasterCode == 'CC' && patternType == 'FLIGHT';
        };

        self.isDistributionCheckApplicable = function (patternType) {
            return patternType == 'FLIGHT';
        };

        self.checkDistributionWarnings = function(masterCrewType, blockId, crewProfileId, isDelete, callback, callBackParams, onCancelWarningsCallback){

            var distributionWarning = ['Pairing distribution violated', 'Do you want continue?'];
            self.checkDistributionWarning(
                blockId,
                crewProfileId,
                onDistributionWarningResponse,
                onDistributionWarningError
            );

            function onDistributionWarningResponse(distributionWarnings) {
                if (distributionWarnings.success) {
                    if(distributionWarnings.warnings.length>0){
                        distributionWarning[0] = distributionWarnings.warnings[0];
                    }

                    if (distributionWarnings.violateCurrentPtn) {
                        showConfirm();
                    } else {
                        if (masterCrewType == 'CC') {
                            self.checkWarnings(blockId, crewProfileId, isDelete, callback, callBackParams, onCancelWarningsCallback);
                        } else {
                            callback(callBackParams);
                        }
                    }
                }
            }

            function onDistributionWarningError(error) {
                MessageService.error(error);
                if (masterCrewType == 'CC') {
                    self.checkWarnings(blockId, crewProfileId, isDelete, callback, callBackParams, onCancelWarningsCallback);
                } else {
                    callback(callBackParams);
                }
            }

            function showConfirm() {
                var param = {
                    title: 'Confirmation',
                    messages: distributionWarning
                };
                PopupManager.openModal('CONFIRM_DIALOG', param, onDistributionWarningConfirmationClose);

                function onDistributionWarningConfirmationClose(param) {
                    if (!!param) {
                        if(masterCrewType=='CC'){
                            self.checkWarnings(blockId, crewProfileId, isDelete, callback, callBackParams, onCancelWarningsCallback);
                        }else{
                            callback(callBackParams);
                        }
                    } else {
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                        if (angular.isDefined(onCancelWarningsCallback)) {
                            onCancelWarningsCallback.call(this);
                        }
                    }
                }
            }

        };

        self.checkWarnings = function (blockId, crewProfileId, isDelete, callback, callBackParams, onCancelWarningsCallback) {

            var warnings = [];

            self.checkLanguageWarning(crewProfileId, isDelete, blockId,
                function (languageWarnings) {
                    if (languageWarnings.warningMessages.length > 0) {
                        warnings = _.union(languageWarnings.warningMessages);
                    }
                    checkGenderWarnings();
                },
                function (error) {
                    MessageService.error(error);
                    checkGenderWarnings();
                }
            );

            function checkGenderWarnings() {
                if (!!isDelete) {
                    self.checkGenderWarningByCrewScheduleId(
                        blockId,
                        crewProfileId,
                        onGenderWarningResponse,
                        onGenderWarningError
                    );
                } else {
                    self.checkGenderWarningByPatternId(
                        blockId,
                        crewProfileId,
                        onGenderWarningResponse,
                        onGenderWarningError
                    );
                }

                function onGenderWarningResponse(genderWarnings) {
                    if (genderWarnings.success && genderWarnings.warnings.length > 0) {
                        warnings = _.union(warnings, genderWarnings.warnings);
                    }
                    if (warnings.length > 0) {
                        showConfirm();
                    } else {
                        callback(callBackParams);
                    }
                }

                function onGenderWarningError(error) {
                    MessageService.error(error);
                }

                function showConfirm() {
                    var param = {
                        title: 'Confirmation',
                        messages: warnings
                    };
                    PopupManager.openModal('CONFIRM_DIALOG', param, onGenderWarningConfirmationClose);

                    function onGenderWarningConfirmationClose(param) {
                        if (!!param) {
                            callback(callBackParams);
                        } else {
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.COLLAPSE_ALL_EXPAND_ROWS);
                            if (angular.isDefined(onCancelWarningsCallback)) {
                                onCancelWarningsCallback.call(this);
                            }
                        }
                    }
                }
            }
         };


        /**
         * Check whether crew schedule is published or not
         * @param crewTypeCode
         * @param fromDate
         * @param toDate
         * @param successFn
         * @param errorFn
         */
        self.checkIsPublished = function (crewTypeCode, fromDate, toDate, successFn, errorFn) {
            var param = CrewingRequest.isPublishedRequest(crewTypeCode, fromDate, toDate);
            RemoteService.checkIsPublished(param).then(
                function (data) {
                    successFn(data.published);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Check whether crew schedule is published or not crew wise
         * @param crewProfileId
         * @param fromDate
         * @param toDate
         * @param successFn
         * @param errorFn
         */
        self.checkIsPublishedByCrewProfileId = function (crewProfileId, fromDate, toDate, successFn, errorFn) {
          var param = CrewingRequest.isCrewPublishedRequest(crewProfileId, fromDate, toDate);
          RemoteService.checkIsPublishedByCrewProfileId(param).then(
            function (data) {
              successFn(data.published);
            },
            function (error) {
              errorFn(error);
            }
          );
        };

        /**
         * Published Schedule helper function;
         * @param crewTypeCode
         * @param fromDate
         * @param toDate
         * @param successFn
         * @param errorFn
         */
        self.schedulePublish = function (crewTypeCode, fromDate, toDate, successFn, errorFn) {
            var param = CrewingRequest.schedulePublishRequest(crewTypeCode, fromDate, toDate);
            RemoteService.schedulePublish(param).then(
                function (data) {
                    successFn(data);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Email Crew Schedule helper function
         * @param crewProfileId
         * @param startDate
         * @param endDate
         * @param successFn
         * @param errorFn
         */
        self.emailCrewSchedule = function (crewProfileId, startDate, endDate, successFn, errorFn) {
            var param = CrewingRequest.crewScheduleEmailRequest(crewProfileId, startDate, endDate);
            RemoteService.emailCrewSchedule(param).then(
                function (data) {
                    successFn(data.success);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get TimeZone helper function
         * @param successFn
         */
        self.getTimeZoneText = function (successFn) {
            CommonMasterData.getTrackingTimeZone(
                function (appParamValueDTO) {
                    var adapted = {};
                    if (!!appParamValueDTO) {
                        adapted.timeZone = appParamValueDTO.paramValue;
                        if (appParamValueDTO.paramValue === 'LOCAL') {
                            adapted.message = '* Schedule displayed in Local Time';
                        } else {
                            adapted.message = '* Schedule displayed in Zulu Time';
                        }
                    }
                    successFn(adapted);
                },
                function (error) {
                    console.log(error);
                }
            );
        };

        /**
         * Assign Direct Event Helper Function
         * @param _crewProfileId
         * @param _eventCode
         * @param _startDate
         * @param _endDate
         * @param _requested
         * @param successFn
         * @param errorFn
         */
        self.assignDirectEvent = function (_crewProfileId, _eventCode, _startDate, _endDate, _requested, isShowInPortal, successFn, errorFn,isCustomDateRange,customDateRange, forceAssignLeave,isUserConfirm,selectedBase) {
            var param = CrewingRequest.assignDirectEventRequest(_crewProfileId, _eventCode, _startDate, _endDate, _requested, isShowInPortal,isCustomDateRange,customDateRange,forceAssignLeave,isUserConfirm,selectedBase);
            RemoteService.assignDirectEvent(param).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Get Assigned Crews for a block helper function
         * @param crewScheduleBlockId
         * @param successFn
         * @param errorFn
         */
        self.getBlockAssignedCrew = function (crewScheduleBlockId, successFn, errorFn) {
            RemoteService.getBlockAssignedCrew(crewScheduleBlockId).then(
                function (response) {
                    successFn(CrewingAdaptor.blockAssignedCrewAdaptor(response));
                },
                function (error) {
                    errorFn(error);
                }
            );
        };

        /**
         * Send Sms helper function
         * @param smsPrams
         * @param successFn
         * @param errorFn
         */
        self.sendSMS = function (smsPrams, successFn, errorFn) {
            var request = CrewingRequest.sendSmsRequest(smsPrams);
            RemoteService.sendSMS(request).then(
                function (response) {
                    successFn(response);
                },
                function (error) {
                    errorFn(error)
                }
            );
        };

        /**
         * Send Alert helper function
         * @param successFn
         * @param errorFn
         */
        self.sendAlert = function (param, successFn, errorFn) {
            var request = CrewingRequest.sendAlertRequest(param);
            RemoteService.sendAlert(request).then(
                function (response) {
                    successFn.call(this, response);
                },
                function (error) {
                    errorFn.call(this, error);
                }
            )
        };

        /**
         * Set Crew Schedule Data For Last Search
         * @param schedule
         */
        self.setCrewScheduleData = function (schedule) {
            crewSchedule = schedule;
        };

        self.getCrewScheduleData = function () {
            return crewSchedule;
        };

        self.setNewlyAddedCrewSchedule = function (crewSchedule) {
        	newlyAddedCrewSchedule = crewSchedule;
        };

        self.getNewlyAddedCrewSchedule = function () {
            return newlyAddedCrewSchedule;
        };


        /**
         * Get Block Details Helper function
         * @param blockId
         * @param crewScheduleBlockId
         * @param isPattern
         * @param successFn
         * @param errorFn
         */
        self.getBlockDetail = function (blockId, crewScheduleBlockId, isPattern, successFn, errorFn) {
            var param = CrewingRequest.searchBlockDetailsRequest(blockId, crewScheduleBlockId, isPattern);
            RemoteService.getBlockDetail(param).then(
                function (response) {
                    successFn.call(this, CrewingAdaptor.blockDetailAdaptor(response));
                },
                function (error) {
                    errorFn.call(this, error);
                }
            );
        };

      self.getBlockDetailTrainings = function (blocks, isPattern, successFn, errorFn) {
        var param = CrewingRequest.searchBlockDetailsTrainingRequest(blocks, isPattern);
        RemoteService.getBlockDetailTraining(param).then(
          function (response) {
            successFn.call(this, CrewingAdaptor.blockDetailTrainingAdaptor(response));
          },
          function (error) {
            errorFn.call(this, error);
          }
        );
      };

        self.getBlockDetailForCrewSchedule = function (blockId, crewScheduleBlockId, isPattern, successFn, errorFn) {
            var param = CrewingRequest.searchBlockDetailsRequest(blockId, crewScheduleBlockId, isPattern);
            RemoteService.getBlockDetail(param).then(
                function (response) {
                    successFn.call(this, CrewingAdaptor.getBlockDetailAdaptorForCrewSchedule(response));
                },
                function (error) {
                    errorFn.call(this, error);
                }
            );
        };



        /**
         * Update Edit Block Update Training program  helper function
         * @param flightLegId,trainingProgramId,trainingProgramDetailId
         * @param successFn
         * @param errorFn
         */
        self.updateTrainingProgram = function (blockId,selectedCrew, continueOveride, pic, crewSchdBlockId, type, flightLegId, trainingProgramId, trainingProgramDetailId, version, successFn, errorFn,selectedFlightLegs, fam) {
            var request = CrewingRequest.editBlockTrainingProgramRQ(selectedCrew, continueOveride, pic, crewSchdBlockId, type, flightLegId, selectedFlightLegs ,trainingProgramId, trainingProgramDetailId, version, fam);
            RemoteService.updateTrainingProgram(request).then(
                function (response) {
                    successFn(CrewingAdaptor.updateTrainingProgramAdaptor(response));
                    getBlockDetails(blockId, crewSchdBlockId, true);

                },
                function (error) {
                    errorFn(error)
                }
            );
        };

        /**
         * Update Trainer Trainee Helper function
         * @param param
         * @param successFn
         * @param errorFn
         */
        self.updateTrainerTrainee = function (param, successFn, errorFn) {
            var request = CrewingRequest.updateTrainerTraineeRequest(param);
            RemoteService.updateTrainerTrainee(request).then(
                function (response) {
                    successFn(response);
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

      self.updateTakeOffLanding = function (param, successFn, errorFn) {
        // var request = CrewingRequest.updateTakeOffLanding(param);
        var blockDetails = param;
        RemoteService.updateTakeOffLandingInfo(param.takeOffLandingDetails).then(
          function (response) {
            successFn(response);
          },
          function (msg) {
            errorFn(msg);
          }
        );
      };

      function getBlockDetails(blockId, crewScheduleBlockId, isPattern) {
        var param = CrewingRequest.searchBlockDetailsRequest(blockId, crewScheduleBlockId, isPattern);
        RemoteService.getBlockDetail(param).then(
          function (response) {
            EventManagerService.notifyEventListeners(EventManagerService.EVENT.TRAINING_FLIGHT_UPDATE, response);
          },
          function (error) {
            errorFn.call(this, error);
          }
        );
      }

        /**
         * Check Gender Warnings by CrewProfileId and PatternId
         * @param patternId
         * @param crewProfileId
         * @param successFn
         * @param errorFn
         */
        self.checkGenderWarningByPatternId = function (patternId, crewProfileId, successFn, errorFn) {
            RemoteService.checkGenderWarningByPatternId(patternId, crewProfileId).then(
                function (response) {
                    successFn(response);
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        /**
         * Check Gender Warnings by CrewProfileId and crewScheduleBlockId
         * @param crewScheduleBlockId
         * @param crewProfileId
         * @param successFn
         * @param errorFn
         */
        self.checkGenderWarningByCrewScheduleId = function (crewScheduleBlockId, crewProfileId, successFn, errorFn) {
            RemoteService.checkGenderWarningByCrewScheduleId(crewScheduleBlockId, crewProfileId).then(
                function (response) {
                    successFn(response);
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        /**
         * Check Language warnings helper function
         * @param crewProfileId,isDelete,blockId
         * @param successFn
         * @param errorFn
         */
        self.checkLanguageWarning = function (crewProfileId, isDelete, blockId, successFn, errorFn) {
            var requestParam = CrewingRequest.languageWarningRequest(crewProfileId, isDelete, blockId);
            RemoteService.checkLanguageWarning(requestParam).then(
                function (response) {
                    successFn(CrewingAdaptor.checkLanguageWarningAdaptor(response));
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        /**
         * Update result for flight
         * @param successFn
         * @param errorFn
         * @param ignoreFlags optional flags to override expiry warnings
         */
        self.updateExpiryFlight = function (selectedFlight, crew, result, remarks, validationNo, successFn, errorFn, ignoreFlags) {
            var requestParam = CrewingRequest.updateFlightExpiryRequest(selectedFlight, crew, result, remarks, validationNo, ignoreFlags);
            RemoteService.updateExpiryFlight(requestParam).then(
                function (response) {
                    successFn(response);
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        /**
         * Update result for training
         * @param successFn
         * @param errorFn
         */
        self.updateExpiryBlock = function (training, crew, result, remarks, validationNo, successFn, errorFn) {
            var requestParam = CrewingRequest.updateBlockExpiryRequest(training, crew, result, remarks,validationNo);
            RemoteService.updateExpiryBlock(requestParam).then(
                function (response) {
                    successFn(response);
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        self.updateExpiryMultipleTrainings = function(expiryDtos, successFn, errorFn) {
          RemoteService.updateExpiryMultipleTrainings(expiryDtos).then(
            function (response) {
              successFn(response);
            },
            function (msg) {
              errorFn(msg);
            }
          )
        };

        /**
         * get Crew Profile Image Helper function
         * @param crewProfileId
         * @param successFn
         * @param errorFn
         */
        self.getCrewImgUrl = function (crewProfileId, successFn, errorFn) {
          RemoteService.getCrewImgDataUrl(crewProfileId)
            .then(function(response){
              if (response){
                CommonLogicService.getDataUrlFromResponse(response)
                  .then(function(dataUrl) {
                    successFn(dataUrl);
                  })
                  .catch(function(error) {
                    errorFn(error);
                  });
              }
            },
            function(error){
              errorFn(error.msg);
            }
          );
        };

        /**
         * check the distribution violation warning
         * @param pairingId
         * @param crewProfileId
         * @param successFn
         * @param errorFn
         */
        self.checkDistributionWarning = function (pairingId, crewProfileId, successFn, errorFn) {
            var requestParam = CrewingRequest.getDistributionWarning(crewProfileId, pairingId);
            RemoteService.checkDistributionWarning(requestParam).then(
                function (response) {
                    successFn(CrewingAdaptor.getDistViolationsAdaptor(response));
                },
                function (msg) {
                    errorFn(msg);
                }
            );
        };

        self.getJoiningCrewList = function (crewScheduleBlockId, isPattern, successFn, errorFn) {
        	var requestParam = CrewingRequest.getJoiningCrewParam(crewScheduleBlockId, isPattern);
        	RemoteService.getJoiningCrewList(requestParam).then(
        		function(response) {
        			if(response.success) {
        				successFn(response);
        			}
        		},
        		function(error) {
        			errorFn(error.msg[0]);
        		}
        	);
        }

        self.getCrewExpiries = function (params, successFn, errorFn) {
        	RemoteService.searchCrewExpiries(params).then(
        		function(response) {
        			if(response.success) {
        				successFn(response);
        			}
        		},
        		function(error) {
        			errorFn(error.msg[0]);
        		}
        	);
        }

        self.getCreditHoursDetails = function (params,successFn, errorFn) {
          var requestParam = CrewingRequest.getCreditHoursParam(params);
          RemoteService.searchCreditHoursDetails(requestParam).then(
            function(response) {
              if(response.success) {
                successFn(response);
              }
            },
            function(error) {
              errorFn(error.msg[0]);
            }
          );
        }

        self.getTrainingStagesDetails = function (crewProfileId, toDate, successFn, errorFn) {
          RemoteService.searchTrainingStagesDetails(crewProfileId, toDate).then(
            function(response) {
              if(response.success) {
                successFn(response);
              }
            },
            function(error) {
              errorFn(error.msg[0]);
            }
          );
        }

        self.syncTrainingStages = function (crewProfileId, successFn, errorFn) {
          var param = {
            crewProfileId: crewProfileId
          }
          RemoteService.syncTrainingStages(param).then(
            function (response) {
              successFn(response)
            },
            function (error) {
              errorFn(error);
            }
          );
        };

      self.searchFlyingHours = function (crewId, fromDate, toDate, successFn, errorFn) {
        var param = CrewingRequest.getFlyingHoursSearchRequest(crewId, fromDate, toDate);
        RemoteService.getFlyingHours(param).then(
          function (response) {
            if(response.success) {
              successFn(response.flyingHours);
            }
          },
          function (error) {
            errorFn(error);
          }
        );
      };

        self.setIsPublished = function(value){
          self.isPublished = value
        }

        self.getIsPublished = function(){
          return self.isPublished;
        }

      self.replacePatternWithOverlapped = function (listDuties, newPattern, crewProfileId, existingCrewScheduleChange, successFn, errorFn) {
          var requestParam = CrewingRequest.replacingOverlappingRequest(listDuties, newPattern, crewProfileId, existingCrewScheduleChange);
          RemoteService.replacePatternWithOverlapped(requestParam).then(
          function(response) {
            if(response.success) {
              successFn(response);
            }
          },
          function(error) {
            errorFn(error.msg[0]);
          }
        );
      }

      self.isViolatingDutyStartLocationtwithPreviousLocation = function (pairingBase, crewProfileId, dutyDate, patternId, successFn, errorFn) {

        var requestParam = CrewingRequest.checkDutyPrevNextBase(pairingBase, crewProfileId, dutyDate, patternId);
        RemoteService.checkDutyPrevNextBase(requestParam).then(
          function(response) {

            if(response.success) {
              successFn(response);
            }
          },
          function(error) {
            errorFn(error.msg[0]);
          }
        );

      };
      self.isViolatingAirportRecency = function (crewProfileId, dutyDate, patternId, successFn, errorFn) {

        var requestParam = CrewingRequest.checkAirportRecency(crewProfileId, patternId, dutyDate);
        RemoteService.checkAirportRecency(requestParam).then(
          function(response) {

            if(response.success) {
              successFn(response);
            }
          },
          function(error) {
            errorFn(error.msg[0]);
          }
        );

      };

      self.searchFlyingMinutes = function (param, successFn, errorFn) {

        RemoteService.searchFlyingMinutes(param).then(
            function(response) {
                successFn(response);
            },
                function(error) {
                  errorFn(error.msg[0]);
                }
            );

      };

      self.setSbyCallOutDateTime = function(sbyCallOutDateTime){
        self.sbyCallOutDateTime = sbyCallOutDateTime
      }

      self.getSbyCallOutDateTime = function(){
        return self.sbyCallOutDateTime;
      }


      self.getDelayedReportTiming = function (param, successFn, errorFn) {
        RemoteService.getDelayedReportTiming(param).then(
          function(response) {
            successFn(response);
          },
          function(error) {
            errorFn(error.msg[0]);
          }
        );

      };

      self.updateDelayedReportTiming = function (param, successFn, errorFn) {
        RemoteService.updateDelayedReportTiming(param).then(
          function(response) {
            successFn(response);
          },
          function(error) {
            errorFn(error.msg[0]);
          }
        );

      };

    }
}());
